import { IoWarning } from "react-icons/io5";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const ErrorDeadEndBanner = ({
  question,
  onBack,
}: QuizQuestionProps<boolean>) => {
  const { title, message, customHTML } = question.attributes || {};

  return (
    <div className="flex flex-col justify-center">
      <h2 className="error-title">{title}</h2>
      <div className="error-message-container">
        <div className="mb-3 sm:mb-4 lg:mb-5">
          <IoWarning className="w-12 sm:w-20 lg:w-24 h-12 sm:h-20 lg:h-24 text-tomato" />
        </div>
        {message && <p>{message}</p>}

        {customHTML && (
          <div
            className="quiz-description"
            dangerouslySetInnerHTML={{ __html: customHTML }}
          />
        )}
      </div>

      <button
        onClick={onBack}
        className="text-white mt-5 bg-brick-red xs:text-xl sm:text-2xl lg:text-[25px] py-4 lg:py-5 px-10 rounded-[36px]"
      >
        Back
      </button>
    </div>
  );
};

export { ErrorDeadEndBanner };
